import { useEffect, useRef } from 'react';

export const useModSubmit = (onSubmit?: (...args: any[]) => void) => {
	const ref = useRef<HTMLFormElement>(null);

	useEffect(() => {
		const input = ref.current;

		if (input) {
			const listener = (e: KeyboardEvent) => {
				if ((e.metaKey || e.ctrlKey) && e.key === 'Enter') {
					onSubmit ? onSubmit(e) : input.submit();
				}
			};

			input.addEventListener('keydown', listener);

			return () => {
				input.removeEventListener('keydown', listener);
			};
		}
	});

	return ref;
};
